<template>
  <div>
    <div v-if="wizard.api_errors && Object.keys(wizard.api_errors).length > 0" class="alert alert-danger mb-4">
      <ul class="my-1 pr-4">
        <li class="text-white" v-for="(errors, field) in wizard.api_errors" :key="field">
          <span v-for="(error, index) in errors" :key="index">{{ error }}</span>
        </li>
      </ul>
    </div>
    <div class="col-12 my-2">
      <label for="settlement_type"> نوع تسویه: </label>
      <div class="d-flex justify-content-center align-items-center">
        <div class="row">
          <div class="col-lg-6 col-md-12 my-2">
            <div
                class="pay-card"
                id="payment-helper"
                @click="toggleCardSelection('#payment-helper')"
            >
              <div class="pay-card-header">
                <p>پرداخت‌یاری</p>
              </div>
              <div class="d-flex flex-column">
                <div
                    class="mb-3"
                    v-for="(
                                        description, index
                                    ) in payment_helper_description"
                    :key="index"
                >
                  <img
                      src="@/pages/dashboard/userwizard/assets/check.svg"
                      width="16"
                      height="16"
                      class="filter_green"
                  />
                  <span
                      class="mx-3"
                      style="font-size: 11px"
                  >{{ description }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 my-2">
            <div
                class="pay-card"
                id="psp"
                @click="toggleCardSelection('#psp')"
            >
              <div class="pay-card-header">
                <p>پرداخت‌یاری-تسویه مستقیم</p>
              </div>
              <div class="d-flex flex-column">
                <div
                    class="mb-3"
                    v-for="(
                                        description, index
                                    ) in psp_description"
                    :key="index"
                >
                  <img
                      src="@/pages/dashboard/userwizard/assets/check.svg"
                      width="16"
                      height="16"
                      class="filter_green"
                  />
                  <span class="mx-3">{{ description }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 my-2">
      <label for="sheba_number">
        {{ $t('label.sheba_number') }}
        <span
            class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
                    <span class="tooltip-text">
                        برای اضافه یا حذف کردن شبا، می‌توان از منو تنظیمات پنل
                        کاربری پی‌استار اقدام کرد.
                    </span>
                    <i class="fa fa-info-circle"></i>
                </span>
      </label>
      <!-- multi select - settlement_type == 1 -->
      <select
          v-if="settlement_type == 1"
          id="sheba_number"
          name="sheba"
          v-model="form_data.sheba"
          class="form-control kt-selectpicker"
          multiple
          size="5"
      >
        <option
            class="en_num"
            v-bind:key="sheba_number.id"
            v-for="sheba_number in sheba_numbers"
            :value="sheba_number.id"
        >
          {{ sheba_number.number }}
        </option>
      </select>

      <!-- single select - settlement_type != 1 -->
      <select
          v-else
          id="sheba_number"
          name="sheba"
          v-model="form_data.sheba"
          class="form-control kt-selectpicker"
      >
        <option value="" disabled>انتخاب شبا</option>
        <option
            class="en_num"
            v-bind:key="sheba_number.id"
            v-for="sheba_number in sheba_numbers"
            :value="sheba_number.id"
        >
          {{ sheba_number.number }}
        </option>
      </select>
      <p class="font-weight-bold mt-4">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#F19E39"
        >
          <path
              d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
          />
        </svg>
        <span v-if="settlement_type == 1" class="mr-2"
        >باید حداقل ۲ شبا در بانک های مختلف انتخاب کنید و همچنین
                    شباهای شما باید در پرونده مالیاتی متصل باشد.</span
        >
        <span v-else class="mr-2"
        >باید فقط یک شبا انتخاب نمایید و در پرونده مالیاتی نیز متصل
                    باشد.</span
        >
      </p>

      <div v-if="settlement_type == 1 && selected_sheba_numbers.length > 0" class="font-weight-bold mt-4">
        <label for="main_settlement_iban">
            {{ $t('label.main_iban_sheba') }}
        </label>

        <select
          id="main_settlement_iban"
          name="main_settlement_iban"
          v-model="form_data.main_settlement_iban"
          class="form-control kt-selectpicker"
          >
          <option value="" disabled>انتخاب شبای اصلی</option>
          <option
            class="en_num"
            v-bind:key="sheba_number.id"
            v-for="sheba_number in selected_sheba_numbers"
            :value="sheba_number.id"
          >
          {{ sheba_number.number }}
          </option>
        </select>
      </div>
      <p v-else-if="settlement_type == 1" class="font-weight-bold mt-4 text-muted">
        <small>{{ $t('label.select_shebas_first') }}</small>
      </p>

    </div>
    <div class="d-flex align-items-center px-3 mt-4">
      <div>
        <button
            type="button"
            @click="step_back()"
            class="btn btn-success px-4"
            style="border-radius: 10px"
        >
          <span>مرحله قبل</span>
        </button>
      </div>

      <div class="mr-auto">
        <button
            v-if="wizard.submit_in_progress"
            type="button"
            disabled
            class="btn btn-success px-4"
            style="border-radius: 10px"
        >
          <div
              class="d-flex align-items-center justify-content-center"
          >
            <div class="mx-2">لطفا صبر کنید</div>
            <div
                class="spinner-border spinner-border-sm text-white"
                role="status"
            ></div>
          </div>
        </button>
        <button
            v-else
            type="submit"
            class="btn btn-success px-4"
            style="border-radius: 10px"
            id="register_btn"
        >
          <span>ثبت درگاه</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { mapGetters } from 'vuex';
import { shopType } from '@/constants/ShopType';
import toastr from 'toastr';
export default {
  name: 'settlement-type',
  data() {
    return {
      payment_helper_description: [
        'تسویه حساب روزانه ساعت ۱۱ صبح به جز ایام تعطیل',
        ' امکان تسهیم بین چند شبا شما یا شرکای تجاری'
      ],
      psp_description: [
        'تسویه حساب روزانه ساعت ۵ صبح حتی ایام تعطیل',
        'عدم امکان تسهیم بین چند شبا شما یا شرکای تجاری'
      ],
      settlement_type: 1,
      shop_type: shopType
    };
  },
  props: {
    is_selected: Boolean,
    wizard: Object,
    form_data: Object
  },
  computed: {
    ...mapGetters('shebaNumber', ['sheba_numbers']),
    selected_sheba_numbers() {
      const selected_ids = Array.isArray(this.form_data.sheba) ? this.form_data.sheba : [];
      return this.sheba_numbers.filter((sheba_number) =>
          selected_ids.includes(sheba_number.id)
      );
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: 'toast-bottom-center',
        preventDuplicates: false,
        rtl: false
      };
      return toastr;
    }
  },
  methods: {
    toggleCardSelection(cardId) {
      if (
          this.form_data.type == this.shop_type.BUSINESS ||
          this.form_data.type == this.shop_type.BUSINESS_PSP_SETTLEMENT
      ) {
        if (cardId == '#psp') {
          this.settlement_type = 2;
          this.form_data.type = 4;
        }

        if (cardId == '#payment-helper') {
          this.settlement_type = 1;
          this.form_data.type = 2;
        }

        this.form_data.settlement_type = this.settlement_type;
        this.form_data.sheba = [];
        this.form_data.main_settlement_iban = '';
        $('.pay-card').removeClass('card-selected');
        $(cardId).addClass('card-selected');
      } else {
        this.toastr.error(
            'برای نوع درگاه انتخاب شده، امکان انتخاب نوع تسویه امکان پذیر نمی باشد.'
        );
      }
    },
    step_back() {
      $('.pay-card').removeClass('card-selected');
      $('#payment-helper').addClass('card-selected');
      this.form_data.settlement_type = 1;
      this.settlement_type = 1;
      this.wizard.api_errors = {};
      this.wizard.current_step = 3;
    },
    renderMainSettlementIbanPicker() {
      this.$nextTick(() => {
        const $select = $('#main_settlement_iban');
        if (!$select.length) {
          return;
        }
        if ($select.data('selectpicker')) {
          $select.selectpicker('refresh');
        } else {
          $select.selectpicker({ size: 5 });
        }
      });
    }
  },
  watch: {
    selected_sheba_numbers() {
      if (this.selected_sheba_numbers.length > 0) {
        this.renderMainSettlementIbanPicker();
      }
    },
    'form_data.sheba'(val) {
      if (this.settlement_type != 1 && !Array.isArray(val)) {
        this.form_data.sheba = val ? [val] : [];
        return;
      }

      const selected_ids = Array.isArray(val) ? val : [];
      if (!selected_ids.includes(this.form_data.main_settlement_iban)) {
        this.form_data.main_settlement_iban = selected_ids.length === 1 ? selected_ids[0] : '';
      }
    }
  },
  mounted() {
    $('#payment-helper').addClass('card-selected');
    this.form_data.settlement_type = this.settlement_type;
    if (!this.form_data.main_settlement_iban) {
      this.form_data.main_settlement_iban = '';
    }
  }
}
</script>

<style scoped>
.pay-card {
  padding: 20px 30px;
  width: 100%;
  border-radius: 10px;
  border: 2px solid #e0e0e0 !important;
  min-height: 170px;
  max-height: fit-content;
  margin: 0 10px;
  cursor: pointer;
}

.pay-card:hover {
  opacity: 0.7;
  transition-duration: 0.2s;
  border-color: #00BEA7 !important;
  color: #00BEA7 !important;
}

.pay-card .pay-card-header {
  text-align: center;
  font-size: 18px;
  margin-bottom: 20px;
}

.filter_green {
  filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}

.card-selected {
  border-color: #00BEA7 !important;
  color: #00BEA7 !important;
}

</style>